import React, { FC } from 'react'
import { ToLOperationsPagePresenter } from './ToLOperationsPagePresenter'
import { ModalsProvider } from '../../../contexts/ModalsContext'

interface ToLOperationsPageProps {
  children?: React.ReactNode
}

export const ToLOperationsPageContainer: FC<ToLOperationsPageProps> = ({ children }) => {
  return <ToLOperationsPagePresenter>{children}</ToLOperationsPagePresenter>
}

export default ({ children }: ToLOperationsPageProps) => {
  return (
    <ModalsProvider>
      <ToLOperationsPageContainer>{children}</ToLOperationsPageContainer>
    </ModalsProvider>
  )
}
